// extracted by mini-css-extract-plugin
export default {"supportColumn_box":"support--supportColumn_box","supportColumns_TextLink":"support--supportColumns_TextLink","supportColumn_border":"support--supportColumn_border"};